import { createApp } from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import router from "./router"; // Import the router configuration

const app = createApp(App);

app.use(router); // Register the router
app.mount("#app");
